__turbopack_context__.v({
  "carousel__container": "carousel-module-scss-module__4O-AYW__carousel__container",
  "carousel__cta-button": "carousel-module-scss-module__4O-AYW__carousel__cta-button",
  "carousel__header": "carousel-module-scss-module__4O-AYW__carousel__header",
  "carousel__header-container": "carousel-module-scss-module__4O-AYW__carousel__header-container",
  "carousel__header-container--secondary": "carousel-module-scss-module__4O-AYW__carousel__header-container--secondary",
  "carousel__item-wrapper": "carousel-module-scss-module__4O-AYW__carousel__item-wrapper",
  "carousel__title": "carousel-module-scss-module__4O-AYW__carousel__title",
  "carousel__title--secondary": "carousel-module-scss-module__4O-AYW__carousel__title--secondary",
  "carousel__title-icon": "carousel-module-scss-module__4O-AYW__carousel__title-icon",
  "carousel__wrapper": "carousel-module-scss-module__4O-AYW__carousel__wrapper",
  "wrapper": "carousel-module-scss-module__4O-AYW__wrapper",
});
